export default __webpack_public_path__ + "static/media/personal_complete.6a25eefb.png";